import { Component } from "@angular/core";

@Component({
  selector: "arrow-left-icon-svg",
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="arrowLeft" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_871_85)">
          <path
            d="M13.5 8H2.5"
            stroke="#2973E0"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 3.5L2.5 8L7 12.5"
            stroke="#2973E0"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_871_85">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </symbol>
    </svg>
  `,
})
export class ArrowLeftIconSvgComponent {}
